import React, { useState , useEffect} from 'react'
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { Grid, Button } from '@mui/material';

import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../components/Modal/modal'
import axios from "axios"
import { URL } from '../../constants/constant';

const EditValueType = ({selectedRows, setOpen, setMessage, getTableData}) => {
    const [showModal, setShowModal] = useState(false);
    const [valueType, setValueType] = useState('');
    const modalButtonClick = () => {
        if (selectedRows.length <= 0) {
            setOpen(true)
            setMessage('Please select a Package first')
            return
        }
        setValueType(selectedRows[0].value_type)
        setShowModal(true)
    }

    const closeModal = () => {
        setValueType('')
        setShowModal(false)
    }

    const handleChange = (event) => {
        setValueType(event.target.value);
      };

    const updateValueType = () => {
        if (valueType === selectedRows[0].value_type) {
            setOpen(true)
            setMessage('You can not set the same value type')
            return
        }

        const user = JSON.parse(localStorage.getItem("loggedInUserDetails")).emailId;

        const data = JSON.stringify({
            "subtest_name" : selectedRows[0].subtest_name,
            "value_type": valueType,
            "user": user
        });
        
        var config = {
            method: 'post',
            url: URL.demystify_url + 'knowledgeBase/switchValueType',
            headers: { 
            'Content-Type': 'application/json'
            },
            data : data
        };

        axios(config)
        .then(function (response) {
            if(response.data.success === 1){
                setOpen(true); 
                setMessage("Value Type edited succesfully"); 
                getTableData();
            }
            else if(response.data.success === 0){
                setOpen(false); 
                setMessage(response.data.errorMessage);
            }
        })
        .catch(function (error) {
            alert("Something went wrong, please try again")
            console.log(error);
        });

        closeModal()
    }

    return (
        <Grid>
            <div className='add-keyword'>
                <Button variant='contained' onClick={modalButtonClick}>
                    Edit Value Type
                </Button>
            </div>

            <div>
                <Modal show={showModal} setShow={setShowModal}>
                    <ModalHeader className='modal-header'>
                        <h2>Edit Value Type</h2>
                    </ModalHeader>
                    <ModalBody>
                        <div className='subtest-name' >
                            <div className='new-key-word' style={{justifyContent:'center'}}>
                                <h3 style={{textAlign:'center',fontWeight:'bold'}}>Sub Test Name :<span>{selectedRows.length>0 ?selectedRows[0].subtest_name:undefined}</span></h3>
                            </div>
                        </div>

                        <div className='value-type-radioButton'>
                            <FormControl>
                                <FormLabel id="value-type-radio">Value Type</FormLabel>

                                <RadioGroup
                                    row
                                    aria-labelledby="value-type-radio"
                                    name="value-types"
                                    value={valueType}
                                    onChange={handleChange}
                                >
                                    <FormControlLabel value="Float" control={<Radio />} label="Float" />
                                    <FormControlLabel value="String" control={<Radio />} label="String" />
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </ModalBody>

                    <ModalFooter>
                        <Button variant="contained" style={{marginRight: 50}} onClick={updateValueType}>Save</Button>
                        <Button onClick={closeModal} variant="outlined">
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        </Grid>
    )
}

export default EditValueType